import Swal from "sweetalert2/dist/sweetalert2.min.js";
import { requestAppPost, requestAppGet } from "@/db/dbManag";
import { getErrorMessage } from "@/utils/getErrorMessage";

export const alertSuccess = message => {
  return Swal.fire({
    html: message,
    icon: "success",
    buttonsStyling: false,
    reverseButtons: true,
    customClass: {
      confirmButton: "btn btn-danger border rounded",
    },
    confirmButtonText: "Chiudi",
    allowOutsideClick: false,
  }).then(() => {
    return true;
  });
};

export const alertWarning = message => {
  return Swal.fire({
    html: message,
    icon: "warning",
    buttonsStyling: false,
    reverseButtons: true,
    customClass: {
      confirmButton: "btn btn-danger border rounded",
    },
    confirmButtonText: "Chiudi",
    allowOutsideClick: false,
  }).then(() => {
    return true;
  });
};

// Alert con due scelte esplicite (es. "Continua a modificare" / "Torna alla lista").
// Ritorna true se l'utente sceglie il pulsante di conferma, false altrimenti.
export const alertChoiceButtons = (message, confirmText, cancelText, icon = "warning") => {
  return Swal.fire({
    html: message,
    icon,
    buttonsStyling: false,
    showCancelButton: true,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    reverseButtons: true,
    allowOutsideClick: false,
    customClass: {
      confirmButton: "btn btn-primary border rounded ms-2",
      cancelButton: "btn btn-secondary border rounded",
    },
  }).then(result => result.isConfirmed);
};

export const alertFailed = message => {
  return Swal.fire({
    html: message ? message : "Attenzione! Si è verificato un errore. Riprovare più tardi.",
    icon: "error",
    buttonsStyling: false,
    reverseButtons: true,
    customClass: {
      confirmButton: "btn btn-danger border rounded",
    },
    confirmButtonText: "Chiudi",
    allowOutsideClick: false,
  }).then(() => {
    return true;
  });
};

// Come alertFailed, ma con il contenitore "esteso" per messaggi lunghi che con il cap
// standard di 200px verrebbero tagliati e costringerebbero a scorrere.
// L'altezza è forzata inline con priorità "important" all'apertura: batte qualsiasi regola
// CSS (comprese quelle su #swal2-html-container) e non dipende dalla compilazione SCSS.
export const alertFailedEsteso = message => {
  return Swal.fire({
    html: message ? message : "Attenzione! Si è verificato un errore. Riprovare più tardi.",
    icon: "error",
    buttonsStyling: false,
    reverseButtons: true,
    customClass: {
      confirmButton: "btn btn-danger border rounded",
    },
    confirmButtonText: "Chiudi",
    allowOutsideClick: false,
    didOpen: () => {
      const el = Swal.getHtmlContainer();
      if (el) {
        el.style.setProperty("max-height", "80vh", "important");
        el.style.setProperty("overflow-y", "auto", "important");
      }
    },
  }).then(() => {
    return true;
  });
};

export const alertFailedNoClose = message => {
  return Swal.fire({
    html: message,
    icon: "error",
    buttonsStyling: false,
    reverseButtons: true,
    customClass: {
      confirmButton: "btn btn-danger border rounded",
    },
    allowOutsideClick: false,
  }).then(() => {
    return true;
  });
};

// Mostra un alert d'errore estraendo il messaggio custom dal backend (vedi getErrorMessage),
// con fallback al messaggio generico se non presente.
export const alertError = (error, fallback) => alertFailed(getErrorMessage(error, fallback));

export const alertErrorNoClose = (error, fallback) => alertFailedNoClose(getErrorMessage(error, fallback));

export const callFunctionAfterAlert = async (endpoint, payload, question, textAlertSuccess, textAlertFailed, nonMostrarePopup) => {
  return Swal.fire({
    html: question ? question : "Sei sicuro?",
    confirmButtonText: "Conferma",
    showCancelButton: true,
    icon: "warning",
    cancelButtonText: "Annulla",
    allowOutsideClick: false,
    showLoaderOnConfirm: true,
    reverseButtons: true,
    customClass: {
      confirmButton: "btn fw-bold btn-light-primary",
      cancelButton: "btn fw-bold btn-light-danger",
    },
    preConfirm: () => {
      return requestAppPost(endpoint, payload).then(({ data, status: reqStatus, statusText }) => {
        return { data, status: reqStatus, statusText };
      });
    },
  }).then(async result => {
    if (result.isConfirmed) {
      const { data, status: reqStatus } = result.value;
      if ((reqStatus != 200 && reqStatus != 204) || (reqStatus == 200 && data.results && data.results[0] && data.results[0].error)) {
        nonMostrarePopup
          ? ""
          : data.results[0].error
          ? alertComposto(data.results, data.record)
          : alertFailed(data.message ? data.message : textAlertFailed);
        return data.record ? true : false;
      } else {
        nonMostrarePopup ? "" : alertSuccess(textAlertSuccess);
        return data;
      }
    } else {
      return false;
    }
  });
};
export const callFunctionAfterAlertGet = async (endpoint, params, question, textAlertSuccess, textAlertFailed, nonMostrarePopup) => {
  return Swal.fire({
    html: question ? question : "Sei sicuro?",
    confirmButtonText: "Conferma",
    showCancelButton: true,
    icon: "warning",
    cancelButtonText: "Annulla",
    allowOutsideClick: false,
    showLoaderOnConfirm: true,
    reverseButtons: true,
    customClass: {
      confirmButton: "btn fw-bold btn-light-primary",
      cancelButton: "btn fw-bold btn-light-danger",
    },
    preConfirm: () => {
      return requestAppGet(endpoint, params).then(({ data, status: reqStatus, statusText }) => {
        return { data, status: reqStatus, statusText };
      });
    },
  }).then(async result => {
    if (result.isConfirmed) {
      const { data, status: reqStatus } = result.value;
      if ((reqStatus != 200 && reqStatus != 204) || (reqStatus == 200 && data.results && data.results[0] && data.results[0].error)) {
        nonMostrarePopup
          ? ""
          : data.results[0].error
          ? alertComposto(data.results, data.record)
          : alertFailed(data.message ? data.message : textAlertFailed);
        return data.record ? true : false;
      } else {
        nonMostrarePopup ? "" : alertSuccess(textAlertSuccess);
        return data;
      }
    } else {
      return false;
    }
  });
};

export const alertComposto = (errori, persone_invitate) => {
  let testoErrori = `Sono presenti i seguenti errori: <br><br><ul>`;
  errori.forEach(element => {
    testoErrori = testoErrori + "<li>" + element.error + "</li>";
  });
  testoErrori = testoErrori + "</ul>";
  if (persone_invitate) {
    testoErrori = testoErrori + "</br> Tutte le altre persone sono state invitate correttamente";
  }
  alertFailed(testoErrori);
};

export const alertChoiceNoFunction = async (question, showButtons = true, icon = "warning") => {
  return Swal.fire({
    html: question ? question : "Sei sicuro?",
    confirmButtonText: "Conferma",
    showCancelButton: true,
    icon,
    cancelButtonText: !showButtons ? "Chiudi" : "Annulla",
    allowOutsideClick: false,
    showLoaderOnConfirm: true,
    reverseButtons: true,
    showConfirmButton: showButtons,
    customClass: {
      confirmButton: "btn fw-bold btn-light-primary",
      cancelButton: "btn fw-bold btn-light-danger",
    },
  }).then(async result => {
    if (result.isConfirmed) {
      return true;
    } else {
      return false;
    }
  });
};

export const alertWithCheckbox = async (title, checkboxLabel) => {
  return Swal.fire({
    title,
    html: `
    <div style="display:flex;align-items:center;gap:8px;">
      <input type="checkbox" id="check1"/>
      <label for="check1">${checkboxLabel}</label>
    </div>
  `,
    confirmButtonText: "Conferma",
    showCancelButton: true,
    cancelButtonText: "Annulla",
    allowOutsideClick: false,
    showLoaderOnConfirm: true,
    reverseButtons: true,
    customClass: {
      confirmButton: "btn fw-bold btn-light-primary",
      cancelButton: "btn fw-bold btn-light-danger",
    },
    didOpen: () => {
      const checkbox = document.getElementById("check1");
      const confirmBtn = Swal.getConfirmButton();
      confirmBtn.disabled = true;

      checkbox.addEventListener("change", () => {
        confirmBtn.disabled = !checkbox.checked;
      });
    },
    preConfirm: () => {
      return {
        checked: document.getElementById("check1").checked,
      };
    },
  });
};
